import { type RouteRecordRaw } from 'vue-router'

import { useAppConfigStore } from '../../shared/store/app-config.store'
import { useGuestTypeStore } from './guestType.store'

export const GuestTypeRouter: RouteRecordRaw[] = [
  {
    path: '/guest-types',
    component: async () => import('./GuestTypes.vue'),
    async beforeEnter() {
      await Promise.all([
        useAppConfigStore.getState().loadAppConfig(),
        useGuestTypeStore.getState().list(),
      ])
    },
  },
]
